// extracted by mini-css-extract-plugin
export default {"container":"SceneActionButtons__container___nMqdj","fullscreen":"SceneActionButtons__fullscreen___sBhdG","dimensionsLabel":"SceneActionButtons__dimensionsLabel___roZZw"};